import { 
	createSlice,
	createSelector,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'

import {
	envAwarePost,
	dateToAPIStandard
} from '../../../util/util'

export const cancelSubscription = createAsyncThunk(
	'subscriptions/cancel',
	async payload => await envAwarePost(
		'api/subscriptions/api/',
		{action:'cancelSubscription',...payload}
	)
)

export const getActiveSubscriptions = createAsyncThunk(
	'getActiveSubscriptions',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'getActiveSubscriptions'}
	)
)

export const toggleClientSubscription = createAsyncThunk(
	'toggleClientSubscription',
	async payload => await envAwarePost(
		'api/subscriptions/',
		{action:'toggleClientSubscription',...payload}
	)
)

const subscriptionsAdapter = createEntityAdapter({
	selectId: ent => ent.subscription_id
})

const slice = createSlice({
	name: 'activeSubscriptions',
	initialState : subscriptionsAdapter.getInitialState({
		status:'init',
		monthlyEstimate:0
	}),
	reducers : {},
	extraReducers : {
		[cancelSubscription.pending] : (state,action) => {
			const {id} = action.meta.arg
			subscriptionsAdapter.removeOne(state,id)
		},
		[getActiveSubscriptions.pending] : (state,action) => { 
			state.status = 'pending' 
		},
		[getActiveSubscriptions.fulfilled] : (state,action) => {
			state.status = 'idle'
			const {client_subscriptions,monthly_estimate} = action.payload.data
			subscriptionsAdapter.upsertMany(state,client_subscriptions)
			state.monthlyEstimate = monthly_estimate
		},
		[toggleClientSubscription.pending] : (state,action)=>{
			const {id,enabled} = action.meta.arg
			subscriptionsAdapter.updateOne(state,{id,changes:{paused:enabled^1}})
		}
	}
})

export const {
	selectAll: selectAllActiveSubscriptions,
	selectById: selectActiveSubscriptionById,
	selectIds: selectActiveSubscriptionIds
} = subscriptionsAdapter.getSelectors( state => state.activeSubscriptions )

export default slice.reducer